import { Grid } from '@mui/material';
import { useSnackbar } from 'notistack';
import React from 'react';
import * as Yup from 'yup';
import { useCreateHelpMutation } from '../../api/apiSlice';
import FormikButton from '../../components/formik/FormikButton';
import FormikInput from '../../components/formik/FormikInput';
import FormikSelect from '../../components/formik/FormikSelect';
import Screen from '../../components/fragments/Screen';
import CardHome from '../../components/legacy/CardHome';
import Form from '../../components/utilities/Form';
import { helpActions } from '../../store/local/contents';
import errorSnackbar from '../../utils/errorSnackbar';

const validate = Yup.object().shape({
    title: Yup.string().required().label('Subject'),
    priority: Yup.string().required().label('Priority'),
    message: Yup.string().required().min(10).label('Message'),
});

export default function HelpScreen() {
    const { enqueueSnackbar } = useSnackbar();
    const [createHelp, { isLoading }] = useCreateHelpMutation();

    const priorities = [
        { label: 'Low', value: 'low' },
        { label: 'Normal', value: 'normal' },
        { label: 'High', value: 'high' },
    ];

    return (
        <Screen title="Help">
            <Grid item xs={12} sx={{ mb: 2 }}>
                <Form
                    validationSchema={validate}
                    onSubmit={async (vals, { resetForm }) => {
                        const { error, data } = await createHelp(vals);

                        errorSnackbar(error, enqueueSnackbar);

                        if (data) {
                            enqueueSnackbar('Message sent!');
                            resetForm();
                        }
                    }}
                    initialValues={{ title: '', priority: '', message: '' }}
                >
                    <FormikInput name="title" label="Subject" />
                    <FormikSelect
                        name="priority"
                        data={priorities}
                        label="Priority"
                    />
                    <FormikInput
                        name="message"
                        rows={5}
                        label="Message"
                        multiline
                    />
                    <FormikButton loading={isLoading} variant="contained">
                        Send
                    </FormikButton>
                </Form>
            </Grid>
            {helpActions.map(
                ({ icon, name, link, full, desc, share, blank }) => {
                    return (
                        <CardHome
                            key={`${name}`}
                            icon={icon}
                            title={name}
                            link={link}
                            full={full}
                            desc={desc}
                            share={share}
                            blank={blank}
                        />
                    );
                }
            )}
        </Screen>
    );
}
